import logo from "../../assets/logo/1.jpg";
import { Link } from "react-router-dom";
import "../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import phoneicon from "../../assets/icons/phonewhite.png";
import mailicon from "../../assets/icons/mailwhite.png";
import tellcellicon from '../../assets/icons/telcell.jpg';
import idramicon from '../../assets/icons/idram.jpg';
import Telegramicon from '../../assets/icons/telegramicon.png';
import Watsappicon from '../../assets/icons/watsappicon.png';
import facebookicon from '../../assets/icons/facebookicon.png';
import instagramicon from '../../assets/icons/instagramicon.png';
import vibericon from '../../assets/icons/vibericon.png';
const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-[#006674]  flex flex-col  justify-start gap-6 items-start">
      <div className="flex flex-wrap p-5  justify-start gap-6 items-start">
        <img src={logo} alt="" className="w-[150px] h-[150px] object-cover" />
        <ul className="flex text-white  w-[300px] text-start max-sm:w-full justify-start items-start flex-col gap-3">
          <h1 className="uppercase text-2xl max-sm:text-xl">{t("aboutus")}</h1>
          {/* <li>
            <Link>{t("asked")}</Link>
          </li> */}
          <li>
            <Link to="/PrivacyPolicy">{t("privacy")}</Link>
          </li>
        </ul>
        <ul className=" flex text-white  w-[300px] max-sm:w-full justify-start items-start flex-col gap-2">
          <li>
            <Link className="text-2xl max-sm:text-xl uppercase"> {t("sitemap")}</Link>
          </li>
          <li>
            <Link to='/'>{t("homepagetext")}</Link>
          </li>
          <li>
            <Link  to="/Companies"> {t("companies")}</Link>
          </li>
          <li>
            <Link to='/Top_Candidates'> {t("TOPcandidates")}</Link>
          </li>
          <li>
            <Link to='/Global_News'> {t("news")}</Link>
          </li>
        </ul>
        <ul className="flex text-white  w-[300px] max-sm:w-full justify-start items-start flex-col gap-2">
          <h1 className="text-2xl max-sm:text-xl uppercase"> {t("foremployers")}</h1>
          <li>
            <Link to='/AboutUs'> {t("whyus")} </Link>
          </li>
          <li>
            <Link to="/EmployerChoose"> {t("registeretasemployer")}</Link>
          </li>
          <li>
            <Link to="/EmployerChoose"> {t("postajob")}</Link>
          </li>
          <li>
            <Link to='/Top_Candidates'>{t("getcandidatelist")}</Link>
          </li>
        </ul>
        <ul className="flex text-white  w-[300px] max-sm:w-full justify-start items-start flex-col gap-2">
          <h1 className="text-2xl max-sm:text-xl uppercase">{t("forcandidates")}</h1>
          <li>
            <Link to='/AboutUs'>{t("whyus")}</Link>
          </li>
          <li>
            <Link to="/WorkerChoose">{t("registeredascandidate")}</Link>
          </li>
          <li>
            <Link to='/search'>{t("searchforjobs")}</Link>
          </li>
          <li>
            <Link to='/BecomeaCandidate'> {t("Become")}</Link>
          </li>
        </ul>
        <ul className="flex text-white  w-[300px] max-sm:w-full justify-start items-start flex-col gap-2">
          <h1 className="uppercase max-sm:text-xl text-2xl">{t("contactus")}</h1>
          <li>
            <Link className="flex justify-start items-center gap-2">
              <img
                className="w-[30px] p-1 border-2 border-white h-[30px] rounded-md object-contain"
                src={mailicon}
                alt=""
              />{" "}
              info@jobway.am
            </Link>
          </li>
          <li>
            <Link className="flex justify-start items-center gap-2">
              <img
                className="w-[30px] p-1 border-2 border-white h-[30px] rounded-md object-contain"
                src={phoneicon}
                alt=""
              />
              <img
                className="w-[30px] border-2 border-white h-[30px] rounded-md object-contain"
                src={vibericon}
                alt=""
              />
              <img
                className="w-[30px] p-[0.5px] border-2 border-white h-[30px] rounded-md object-contain"
                src={Watsappicon}
                alt=""
              />
              ‪+374 44 66 40 09‬
            </Link>
          </li>
          <ul className="flex justify-center items-center gap-3">
            <li>{/* <Link><FontAwesomeIcon icon={}/></Link> */}</li>
            <li>{/* <Link><FontAwesomeIcon icon={}/></Link> */}</li>
          </ul>
          <h1 className="font-bold">{t("followus")}</h1>
          <ul className="flex justify-center items-center gap-1">
            <li>
              <Link to="https://www.facebook.com/share/17A5keDinH/?mibextid=wwXIfr" className="w-[35px] flex h-[35px] rounded-full">
                <img
                  className="w-[30px] border-2 border-white h-[30px] rounded-md object-contain"
                  src={facebookicon}
                  alt=""
                />
              </Link>
            </li>
            <li>
              <Link to="https://www.instagram.com/jobway.am?igsh=OGdybjBvNG5nM2Jk" className="w-[35px] flex h-[35px] rounded-full">
                <img
                  className="w-[30px] border-2 border-white h-[30px] rounded-md object-contain"
                  src={instagramicon}
                  alt=""
                />
              </Link>
            </li>
            <li>
              <Link to="https://t.me/jobwayam" className="w-[35px] flex h-[35px] rounded-full">
                 <img
                  className="w-[30px] border-2 border-white h-[30px] rounded-md object-contain"
                  src={Telegramicon}
                  alt=""
                />
              </Link>
            </li>
          </ul>
        </ul>
      </div>
      <div className="flex w-full max-sm:flex-col max-sm:items-start p-5 border-t-[1px] border-white justify-between items-center gap-6">
        <Link className="border-[1px] flex justify-start items-center gap-3 text-white border-white rounded-full py-2 px-3">
          {t("paymentmethods")}
          <img src={tellcellicon} className="w-[30px] h-[30px] object-contain rounded-full" alt="" />
          <img src={idramicon} className="w-[30px] h-[30px] object-contain rounded-full" alt="" />
        </Link>

        <p className="text-white text-center max-sm:text-start"><Link className=" text-white ">
          © Jobway.am 2025
        </Link>
        {t("Reserved")}</p>
      </div>
    </footer>
  );
};

export default Footer;
